import React from "react";
import {connect} from "react-redux";
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  TextInput,
  translate,
  BooleanInput
} from "admin-on-rest";
import SelectInput from "../../../../../components/CRM/SelectInput";
import AutocompleteInput from "../../../../../components/CRM/AutocompleteInput";
import TextField from "../../../../../components/CRM/TextField";
import DateInput from "../../../../../components/DateInput";
import DateTimeInput from "../../../../../components/DateTimeInput";
import {EmbeddedArrayInput} from "aor-embedded-array";
import AutoComplete from "material-ui/AutoComplete";
import restClient from "../../../../../restClient";
import {CREATE} from "admin-on-rest";
import {
  validateVirtualSlipDataEdit,
  required,
  validateBoost,
  validateBoostIdentificationNumber,
  validateStoreName
} from "../../validations";
import {showNotification as showNotificationAction} from "admin-on-rest";
import {formStyle, listStyle} from "../../style";
import Checkbox from "material-ui/Checkbox";
import {bindActionCreators} from "redux";
import {reduxForm, change as changeFieldValue} from "redux-form";
import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
import {BMTheme} from "../../../../../BMTheme";

const LinkFieldBase = ({record = {}, translate}) => (
  <div style={formStyle.textFieldContainer}>
    <span style={formStyle.labelFieldStyle}>
      {translate("resources.virtualSlips.fields.link")}:
    </span>

    <span style={formStyle.textFieldStyle}>
      <a style={listStyle.linkStyle} href={record.short_url} target="blank">
        {record.short_url}
      </a>
    </span>
  </div>
);

const LinkField = translate(LinkFieldBase);

class V75EditFormBase extends React.Component {
  state = {
    isLoading: false,
    isSent: false
  };

  componentWillMount() {
    const record = this.props.record;
    if (record && (record.boost.digits !== "" || record.boost.price !== "")) {
      this.setState({boost: true});
    } else {
      this.setState({boost: false});
    }
  }

  toggleBoost = () => {
    if (this.state.boost === false) {
      this.setState({boost: true});
    } else {
      this.setState({boost: false});
      this.props.changeFieldValue("record-form", "boost.price", "");
      this.props.changeFieldValue("record-form", "boost.digits", "");
    }
  };

  handleSendButton = () => {
    const {showNotification} = this.props;
    this.setState({isLoading: true});
    const slipID = this.props.record.id;
    const slipData = {
      kiosk_id: this.props.record.kiosk_id,
      virtualslip_id: slipID
    };
    restClient(CREATE, "notifications", {data: slipData})
      .then(() => {
        this.setState({isLoading: false, isSent: true});
        showNotification("aor.notification.sent");
        const {history} = this.props;
        history.replace(`/virtualslips`);
      })

      .catch(error => {
        showNotification(error.message, "warning");
      });
  };

  render() {
    const props = {...this.props};
    const record = {...props.record};

    const {isLoading} = this.state;
    const {translate} = this.props;

    if (props.record && props.record.bet_lines) {
      props.record.bet_lines.forEach((pair, index) => {
        pair.rowNumber = index + 1 + ".";
      });
    }

    return (
      <Edit title="resources.virtualSlips.titleEdit" {...props}>
        <SimpleForm redirect="edit" validate={validateVirtualSlipDataEdit}>
          <LinkField source="short_url" />
          <SelectInput
            selectInputStateSet={this.props.selectInputStateSet}
            label="resources.virtualSlips.inputs.betType"
            elStyle={formStyle.selectInput}
            source="type"
            choices={this.props.betItems}
            translateChoice={false}
            rowNumber
            disabled={true}
            style={formStyle.containerInput}
          />
          <ReferenceInput
            label="resources.virtualSlips.inputs.storeName"
            source="kiosk_id"
            reference="kiosks"
            validate={validateStoreName}
            sort={{field: "name", order: "ASC"}}
            perPage={50}
            allowEmpty={false}
            filterToQuery={name => ({name_like: name})}
            style={formStyle.containerInput}
          >
            <AutocompleteInput
              defaultValue={record.store_name}
              options={{filter: AutoComplete.caseInsensitiveFilter}}
            />
          </ReferenceInput>

          <TextInput
            label="resources.virtualSlips.inputs.expert"
            source="expert"
            style={formStyle.containerInput}
          />

          <div style={formStyle.clearDiv} />
          <TextInput
            label="resources.virtualSlips.inputs.sharegameSize"
            source="shares"
            style={formStyle.containerInput}
          />

          <TextInput
            label="resources.virtualSlips.inputs.agentCharge"
            source="agent_charge"
            style={formStyle.containerInput}
          />

          <TextInput
            label="resources.virtualSlips.inputs.shareCost"
            source="share_cost"
          />
          <div style={formStyle.clearDiv} />
          <DateInput
            label="resources.virtualSlips.inputs.startDate"
            source="start_date"
            locale="sv"
            hideCalendarDate={true}
            showIcon={false}
            style={formStyle.containerInput}
            textFieldStyle={formStyle.dateInput.textFieldStyle}
            customInputStyle={formStyle.dateInput.customInputStyle}
          />

          <DateTimeInput
            label="resources.virtualSlips.inputs.betClosingTime"
            source="closing_time"
            locale="sv"
            hideCalendarDate={true}
            showIcon={false}
            textFieldStyle={formStyle.dateInput.textFieldStyle}
            customInputStyle={formStyle.dateInput.customInputStyle}
            wrapperStyle={formStyle.dateInput.wrapperStyle}
            timeStyle={formStyle.dateInput.timeStyle}
          />
          <div>
            <Checkbox
              label="Boost"
              labelPosition="left"
              style={formStyle.checkboxStyle}
              onCheck={this.toggleBoost}
              checked={this.state.boost}
            />
          </div>
          {this.state.boost && (
            <TextInput
              label="Boost"
              source="boost.price"
              validate={validateBoost}
            />
          )}
          {this.state.boost && (
            <TextInput
              label="Boost Identification Number"
              source="boost.digits"
              validate={validateBoostIdentificationNumber}
            />
          )}
          <div style={formStyle.clearDiv} />
          <EmbeddedArrayInput
            label="Bet list"
            source="bet_lines"
            allowAdd={false}
            allowRemove={false}
            insertDividers={false}
            innerContainerStyle={formStyle.arrayInput.innerContainerStyle}
            labelContainerStyle={formStyle.arrayInput.labelContainerStyle}
          >
            <TextField
              label=""
              source="rowNumber"
              recordStyle={formStyle.textInput.rowNumberStyle}
            />
            <TextInput
              label=""
              source="horses"
              validate={required}
              elStyle={formStyle.textInput.horsesStyle}
            />
            <TextInput
              label=" "
              source="reserve"
              validate={required}
              elStyle={formStyle.textInput.reserveStyle}
            />

            <div style={formStyle.clearDiv} />
          </EmbeddedArrayInput>
          <BooleanInput
            label="resources.gametips.inputs.published"
            source="published"
          />
          <div>
            <RaisedButton
              label={
                isLoading === true ? (
                  <CircularProgress
                    size={25}
                    thickness={2}
                    color={BMTheme.palette.alternateTextColor}
                    style={{marginTop: "0.2em"}}
                  />
                ) : (
                  <span style={{color: BMTheme.palette.alternateTextColor}}>
                    {translate("aor.action.send")}
                  </span>
                )
              }
              onClick={this.handleSendButton}
              primary
              style={{marginTop: "2%"}}
              labelColor={BMTheme.palette.alternateTextColor}
              disabled={
                (this.props.record && this.props.record.sent_at) ||
                this.state.isSent === true
                  ? true
                  : false
              }
            />
          </div>
        </SimpleForm>
      </Edit>
    );
  }
}

const V75EditFormTranslated = translate(V75EditFormBase);

const mapStateToProps = (state, props) => ({
  isLoading: state.admin.loading > 0,
  id: decodeURIComponent(props.match.params.id),
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null,
  errors: state.form[`record-form`]
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {changeFieldValue, showNotification: showNotificationAction},
    dispatch
  );
};

const V75EditForm = reduxForm({
  form: "record-form",
  fields: ["boost.price", "boost.digits"]
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(V75EditFormTranslated)
);
export default V75EditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/TicketLayouts/V75/V75EditForm.js